module.exports = __webpack_public_path__ + "img/38-r.80aeb185.png";